import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const CustomerSurveys = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Müşteri Anketleri
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Müşteri anketleri burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default CustomerSurveys;
